// /userInfo/2144/id => ['/userInfo','/userInfo/2144,'/userInfo/2144/id']
/**
 *
 * @deprecated 换成useMatchMenuItem直接匹配
 * @param url
 * @param resourceListMap
 * @param isMenuUrlAddSystemName
 * @returns
 */
export const urlToList = (url, resourceListMap = {}, isMenuUrlAddSystemName = true) => {
    if (!url || url === '/') {
        return ['/'];
    }
    if (resourceListMap[url]) {
        let match = resourceListMap[url];
        let initArr = [match.key];
        while (match) {
            const _pid = match['_pid'];
            if (_pid) {
                initArr.push(_pid);
                match = resourceListMap[_pid];
            }
            else {
                match = null;
            }
        }
        return initArr;
    }
    else {
        const urlList = url.split('/').filter((i) => i);
        return urlList.map((urlItem, index) => `/${urlList.slice(0, index + 1).join('/')}`);
    }
};
export const patternPath = (path) => {
    if (path && path.startsWith('/')) {
        return path;
    }
    else {
        return `/${path}`;
    }
};
